import { useEffect, useState, useContext } from "react"
import PageListItem from "./pageListItem"
import axios from 'axios';
import {baseURL, jwtName} from "../../constants"
import Cookies from 'universal-cookie';
import { isNeitherNullNorUndefined } from "../../utils/functions";
import {PageTreeContext} from "../../context/pageTreeContext"
import { useNavigate } from 'react-router-dom';



export default function FavoritePages(){
    const [pagesAndExercises, setPagesAndExercises] = useState()
    const [pages, setPages] = useState()
    const [exercises, setExercises] = useState()
    const navigate = useNavigate();
    const cookies = new Cookies()
    const pageTreeContextValue = useContext(PageTreeContext);


    async function getFavoritePages(){
        const jwt = cookies.get(jwtName)
         try {
             const response = await axios.get(baseURL + "/favoritePages", {headers: {
                 'Authorization': `bearer ${jwt}`
             }});
             if(response.data){
                 setPagesAndExercises(response.data)
             }
         } catch (error) {
             console.error("error", error.message);
         } 
     }


    useEffect(() => {  
        //TODO: bad practice to check for login on every page, use protected routes instead.
        const jwt = cookies.get(jwtName)
        if(jwt){
            async function getFavoritePagesWrapper(){
                await getFavoritePages()
            }
            pageTreeContextValue.changeIsBreadcrumbsVisible(false)
            getFavoritePagesWrapper()
        }else {
            navigate('/')
        }
    }, [])


    useEffect(() => {  
        if(pagesAndExercises){
            const favPages = pagesAndExercises.filter(entry => {
                if(entry.saveAsPage === 1 && entry.saveAsExercise !== 1){
                    // show as page only if it ins't also an exercise
                    return entry
                }
            })
            const favExercises = pagesAndExercises.filter(entry => {
                if(entry.saveAsExercise === 1){
                    return entry
                }
            })
            favPages && setPages(favPages)
            favExercises && setExercises(favExercises)
        }
    }, [pagesAndExercises])






    return(
        <div>
            {(pages && pages.length > 0) || (exercises && exercises.length > 0) 
            ?
            <div className="favoritesWrapper">
                <div>
                    <div className="favoritesColumnTitle ">Meine Inhalte</div>
                    {
                        pages !== null && typeof(pages) !== "undefined"
                        ? 
                        pages.map(fav => {
                            return <PageListItem title={fav.pageTitle} id={fav.pageID} key={fav.pageID} 
                                        isExercise={false}
                                        triggerUpdateAfterDelete={getFavoritePages} />
                        })
                        :
                        <div>Loading</div>
                    }
                </div>
                <div className="">
                    <div className="favoritesColumnTitle " >Meine Übungssammlung</div>
                    {
                        exercises !== null && typeof(exercises) !== "undefined"
                        ? 
                        exercises.map(fav => {
                            return <PageListItem title={fav.pageTitle} id={fav.pageID} key={fav.pageID}
                                        isExercise={true}
                                        triggerUpdateAfterDelete={getFavoritePages} />
                        })
                        :
                        <div>Loading</div>
                    }
                </div>
            </div>
            :
            <div className="favoritesWrapper">Sie haben noch keine Seiten oder Übungen gespeichert.</div>
            }
        </div>
    )
}